/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var SpinnerRingIcon = createIcon("SpinnerRingIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#0045DB';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0a.954.954 0 110 1.907A6.1 6.1 0 001.907 8 6.1 6.1 0 008 14.093 6.1 6.1 0 0014.093 8 .954.954 0 1116 8c0 4.411-3.589 8-8 8s-8-3.589-8-8 3.589-8 8-8Z",
    fill: _color
  }));
}, {
  "replaceColor": true
});